// https://stackoverflow.com/questions/8936610/how-can-i-create-every-combination-possible-for-the-contents-of-two-arrays
function combineArrays<T>(array_of_arrays: Array<Array<T>>): Array<Array<T>> {
  if (array_of_arrays.length === 0) {
    return [];
  }

  for (let i = 0; i < array_of_arrays.length; i++) {
    if (array_of_arrays[i].length === 0) {
      // If any of the arrays in array_of_arrays are not arrays or are zero-length array, return an empty array...
      return [];
    }
  }

  // Done with degenerate cases...
  const outputs: Array<Array<T>> = [];

  const permute = (arrayOfArrays: Array<Array<T>>, whichArray = 0, output: Array<T> = []) => {
    arrayOfArrays[whichArray].forEach((array_element: T) => {
      if (whichArray === array_of_arrays.length - 1) {
        // Base case...
        outputs.push([...output, array_element]);
      } else {
        // Recursive case...
        permute(arrayOfArrays, whichArray + 1, [...output, array_element]);
      }
    });
  };

  permute(array_of_arrays);

  return outputs;
}

export default combineArrays;
